import React from 'react'

const Select = ({id, label, value, onChange , className, children}) => {
  return (
    <>
      <label>{label}<span style={{ color: "red" }}>*</span></label>
      <select id={id} value={value} onChange={onChange} className={className} >
        {children}
      </select>
    </>
  )
}

export default Select 


